import { WellWish } from "../../types/wellwish";
import { generateAPI } from "../api.generator";

export const getTextAndGifWellWishes = generateAPI<
  {
    query: {
      page: number;
    };
  },
  {
    wellWishesCount: number;
    wellWishes: WellWish[];
  }
>("get", "well-wish/text-and-gif/all");
